module.exports = __webpack_public_path__ + "static/media/crop2.f7d6e687.png";